exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".graph-container[data-v-1a1ccc82] {\n  height: 300px;\n}\n", ""]);

// exports
